// Markaziy API URL — barcha component'lar shu yerdan import qiladi.
// Production'da REACT_APP_API_URL env'ni o'rnating (website-react/.env.production).
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://api.ostona-uy.uz/api/v1';
